/**
 * Euclidean distance for sim logic. Every sim distance goes through here so
 * the implementation is decided in exactly one place.
 *
 * sqrt(dx*dx + dy*dy), NOT Math.hypot (which the prototype used): Math.sqrt is
 * IEEE-754 correctly rounded and therefore bit-identical across JS engines,
 * while Math.hypot is implementation-approximated per ECMA-262 and may differ
 * between V8 and JavaScriptCore -- a cross-engine replay-desync hazard. The
 * switch was validated empirically: the entire golden corpus (recorded under
 * hypot) re-simulates bit-exactly under sqrt. See decisions/0004. Game-scale
 * magnitudes (<= ~1300) make hypot's overflow protection irrelevant here.
 */
export function dist(dx: number, dy: number): number {
  return Math.sqrt(dx * dx + dy * dy);
}
